import { Stack, Text } from '@mantine/core'
import type { KeyDataItem } from '../../../types/keyDataItem'
import { KeyDataRow } from './KeyDataRow'

export interface ClaimKeyDataProps {
  items: KeyDataItem[]
  onActionClick?: (item: string) => void
}

export function ClaimKeyData({ items, onActionClick }: Readonly<ClaimKeyDataProps>) {
  return (
    <Stack gap="xs">
      <Text fz="xs" c="text.2">
        Summary of Key Data:
      </Text>
      <Stack gap={4}>
        {items.map((item: KeyDataItem) => (
          <KeyDataRow
            key={item.label}
            label={item.label}
            value={item.value}
            actionIcon={item.actionIcon}
            actionIconSize={item.actionIconSize}
            onActionClick={() => (onActionClick ? onActionClick(item.label) : undefined)}
          />
        ))}
      </Stack>
    </Stack>
  )
}
